module.exports = __webpack_public_path__ + "img/ico-file.aecd681f.svg";